export default {
  sliders: state => state.sliders,
  values: state => state.texts.filter(text => text.type == 'value'),
  text: state => type => state.texts.filter(text => text.type == type)[0],
  banner: state => state.banner,
}